import Color from 'color';
import { FORMS_INBOX_BADGE_RED } from 'pages/Forms/formsInboxBadgeTheme';
import { lFColor0, mobileRes } from 'pages/components/LFHeader/LFHeader.styled';
import { overlayZIndex } from 'pages/components/Modal/Modal.styled';
import styled from 'styled-components';

const layoutAlertZIndex = overlayZIndex + 150;
const layoutAlertBelowOverlaysZIndex = 1;

const requestPurple = '#6d28d9';
const ink = '#1c1c1c';
const inkMuted = '#6c757d';
const line = '#e9ecef';

export const Container = styled.div<{ $belowOverlays?: boolean }>`
  position: relative;
  z-index: ${({ $belowOverlays }) => (
    $belowOverlays ? layoutAlertBelowOverlaysZIndex : layoutAlertZIndex
  )};
  width: 100%;
  min-height: 58px;
  background: #ffffff;
  border-bottom: 1px solid ${line};
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  color: ${ink};
  flex-shrink: 0;
  @media (max-width: ${mobileRes}) {
    grid-template-columns: 1fr;
    align-items: start;
    gap: 10px;
    padding: 12px 14px;
  }
`;

export const Categories = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const CategoryBtn = styled.button<{ $accent: string }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px 6px 8px;
  border-radius: 999px;
  border: 1.5px solid ${line};
  background: #ffffff;
  color: ${ink};
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.12s ease;
  &:hover {
    border-color: ${({ $accent }) => Color($accent).alpha(0.45).toString()};
    background: ${({ $accent }) => Color($accent).alpha(0.06).toString()};
  }
  &:active {
    transform: scale(0.98);
  }
`;

export const CategoryIcon = styled.span<{ $accent: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: ${({ $accent }) => Color($accent).alpha(0.1).toString()};
  color: ${({ $accent }) => $accent};
  flex-shrink: 0;
  & svg {
    font-size: 17px;
  }
`;

export const CategoryLabel = styled.span`
  font-size: 12.5px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
`;

export const CountBadge = styled.span<{ $accent: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  color: #ffffff;
  background: ${({ $accent }) => $accent};
`;

export const Body = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const LatestLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${inkMuted};
`;

export const LatestText = styled.div`
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.35;
  color: ${ink};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
  @media (max-width: ${mobileRes}) {
    width: 100%;
    justify-content: stretch;
  }
`;

const actionBtnBase = `
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
  @media (max-width: ${mobileRes}) {
    flex: 1;
    min-width: 0;
  }
`;

export const SecondaryBtn = styled.button`
  ${actionBtnBase}
  border: 1.5px solid ${line};
  background: #ffffff;
  color: ${inkMuted};
  &:hover {
    background: #f8f9fa;
    color: ${ink};
  }
`;

export const PrimaryBtn = styled.button`
  ${actionBtnBase}
  border: none;
  background: ${lFColor0};
  color: #ffffff;
  &:hover {
    background: ${Color(lFColor0).darken(0.08).toString()};
  }
`;

export const reportCategoryAccent = FORMS_INBOX_BADGE_RED;
export const requestCategoryAccent = requestPurple;
